import { getConfig } from '@edx/frontend-platform';
import { getCookies } from '@edx/frontend-platform/i18n/lib';
import { useEffect, useState } from 'react';

export function useDarkMode() {

  const LMS_BASE_URL = getConfig().LMS_BASE_URL;
  const [isDarkMode, setIsDarkMode] = useState(false);
  const domain = `.${LMS_BASE_URL.split('://')[1].split(':')[0]}`;
  const features_enable_dark_toggle = getConfig().BLENDX_ENABLE_DARK_TOGGLE;

  useEffect(() => {
    if (!features_enable_dark_toggle) {
      return;
    }
    const darkModeSetting = getCookies().get('isDarkMode');
    if (darkModeSetting === 'true') {
      setIsDarkMode(true);
      document.documentElement.setAttribute('data-theme', 'dark');
    } else if (darkModeSetting === 'false') {
      setIsDarkMode(false);
      document.documentElement.setAttribute('data-theme', 'light');
    } else {
      // Check system preference if no cookie is set
      const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      setIsDarkMode(systemPrefersDark);
      document.documentElement.setAttribute('data-theme', systemPrefersDark ? 'dark' : 'light');
    }

    // Listen for system theme changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      const darkModeSetting = getCookies().get('isDarkMode');
      if (darkModeSetting === undefined) {
        setIsDarkMode(e.matches);
        document.documentElement.setAttribute('data-theme', e.matches ? 'dark' : 'light');
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const toggleDarkMode = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    document.documentElement.setAttribute('data-theme', newMode ? 'dark' : 'light');
    getCookies().set('isDarkMode', newMode.toString(), { domain, path: '/' });
  };

  return { isDarkMode, toggleDarkMode };
}